module.exports = __webpack_public_path__ + "img/logo.7ba5433f.png";